import CryptoJS from "crypto-js"
import {getToken} from '@/utils/auth'
import md5 from 'js-md5';

const modulePath = 'gm'
const roleAdmin = 0
const roleUser = 1

const RES_STATUS_ZERO = 0;
const RES_STATUS_ONE = 1;


const PUSHAPI = 'v1/api'

const isHttps = window.location.protocol === 'https:';
let hostApi = process.env.VUE_APP_BASE_API

if(isHttps){
  hostApi = 'https://'+process.env.VUE_APP_BASE_API
}else{
  hostApi = 'http://'+process.env.VUE_APP_BASE_API
}

export const $my = {

    pushApi : PUSHAPI, //路由+
    md5:1,

    //图片上传地址
    LogoImg: hostApi +'/' + PUSHAPI + '/upload/Logo_img',
    faceImg: hostApi +'/' + PUSHAPI + '/upload/faceImg',

    
    

    colors: {
        primary: '#409EFF',
        success: '#67C23A',
        warning: '#E6A23C',
        danger: '#F56C6C',
        info: '#909399',

        black: '#000000',
        white: '#ffffff',

        text1: '#303133',
        text2: '#606266',
        text3: '#909399',
        text4: '#C0C4CC',

        border1: '#DCDFE6',
        border2: '#E4E7ED',
        border3: '#EBEEF5',
        border4: '#F2F6FC'
    },
    hardwareStatus: {
        val0: {
            type: 'danger',
            label: '离线',
            value: 0
        },
        val1: {
            type: 'success',
            label: '在线',
            value: 1
        }
    },
    hardwareCursorStatus: {
        val0: {
            type: 'success',
            label: '未使用',
            value: 0
        },
        val1: {
            type: 'danger',
            label: '已使用',
            value: 1
        },
        val2: {
            type: 'danger',
            label: '私有化使用',
            value: 2
        }
    },
    hardwareCursorLicenseValue: {
        val0: {
            type: 'success',
            label: 'ALL',
            value: 0
        },
        val1: {
            type: 'danger',
            label: 'License不为空',
            value: 1
        },
        val2: {
            type: 'danger',
            label: 'License为空',
            value: 2
        }
    },
    stusStatus: {
        val0: {
            type: 'info',
            label: '关闭',
            value: 0
        },
        val1: {
            type: 'success',
            label: '开启',
            value: 1
        }
    },
    templateTypes: {
        val1: {
            type: 'info',
            label: '会议屏模板',
            value: 1
        },
        val0: {
            type: 'success',
            label: '综合屏模板',
            value: 0
        }
    },
    templateLayout: {
        val1: {
            value: 1,
            label: '横屏'
        },
        val2: {
            value: 2,
            label: '竖屏'
        }
    },
    templatePub: {
        val1: {
            value: 1,
            label: '系统模板'
        },
        val2: {
            value: 2,
            label: '自定义模板'
        }
    },
    templateSize: {
        val1: {
            value: 1,
            label: '1920x1080',
        },
        val2: {
            value: 2,
            label: '1280x800',
        },
        val3: {
            value: 3,
            label: '800x1280',
        },
        val4: {
            value: 4,
            label: '1080x1920',
        }
    },
    templatePub: {
        val1: {
            value: 1,
            label: '系统模板'
        },
        val2: {
            value: 2,
            label: '用户模板'
        }
    },
    myPaginate: {
        page: 1,
        size: 10,
        pageSizes: [10, 30, 50]
    },
    settings: {
        change_stus_type: {
            val0: {
                label: '不需要密码改变状态',
                value: 0
            },
            val1: {
                label: '需要密码才改变状态',
                value: 1
            },
        },
        open_door_type: {
            val1: {
                value: 1,
                label: '任何时候开门'
            },
            val2: {
                value: 2,
                label: '会议期间开门'
            },
            val3: {
                value: 3,
                label: '用户权限开门'
            },
            // val4: {
            //     value: 4,
            //     label: '密码推送开门'
            // },
        },
    },
    sign_type:{
        val0: {
            value: 0,
            label: '未签合同'
        },
        val1: {
            value: 1,
            label: '正式合同'
        },
        val2: {
            value: 2,
            label: '测试合同'
        }
    },
    project_schedule:{
        val0: {
            value: 0,
            label: '测试项目'
        },
        val1: {
            value: 1,
            label: '已签合同'
        },
        val2: {
            value: 2,
            label: '项目部署'
        },
        val3: {
            value: 3,
            label: '部署完成'
        },
        val4: {
            value: 4,
            label: '需求更改'
        },
        val5: {
            value: 5,
            label: '项目完成'
        },
        val6: {
            value: 6,
            label: '项目催收'
        },
        val7: {
            value: 7,
            label: '项目结束'
        },

    },

    modulePath: modulePath, //请求接口后面加的路径

    companyUploadUrl:process.env.VUE_APP_BASE_API + '/' + modulePath + '/uploads/flow_img',
    freeUploadUrl: process.env.VUE_APP_BASE_API + '/' + modulePath + '/uploads/template_avatar',
    ingUploadUrl: process.env.VUE_APP_BASE_API + '/' + modulePath + '/uploads/template_avatar',
    userUploadUrl: process.env.VUE_APP_BASE_API + '/' + modulePath + '/uploads/user_avatar',
    hardwareLicenseUploadUrl: process.env.VUE_APP_BASE_API + '/' + modulePath + '/uploads/hardware_license',



    tokenKey: 'Authorization',

    systemName: 'GOODEEY 会议预约系统',

    roleAdmin: roleAdmin,
    roleUser: roleUser,

    // 根据value获取到整个item对象
    getByValue(type, obj) {
        let res = {}
        for (let item in obj) {
            if (obj[item].value === type) {
                res = obj[item]
                break
            }
        }
        return res
    },

    // 自定义组件，根据对象的key获取描述名
    myComponentsGetName(key) {
        let str = ''
        let arr = [
            {
                key: 'x',
                title: '左'
            },
            {
                key: 'y',
                title: '上'
            },
            {
                key: 'w',
                title: '宽'
            },
            {
                key: 'h',
                title: '高'
            },
            {
                key: 'text',
                title: '文字'
            },
            {
                key: 'fontColor',
                title: '文字颜色'
            },
            {
                key: 'backgroundColor',
                title: '背景颜色'
            },
            {
                key: 'fontSize',
                title: '文字大小'
            }, {
                key: 'lineHeight',
                title: '行高'
            },
            {
                key: 'letterSpacing',
                title: '字符间距'
            },
            {
                key: 'align',
                title: '对齐方式'
            },
            {
                key: 'bold',
                title: '加粗'
            },
            {
                key: 'italic',
                title: '斜体'
            },
            {
                key: 'underline',
                title: '下划线'
            },
            {
                key: 'src',
                title: '图片'
            },

            {
                key: 'lists',
                title: '轮播列表'
            },
            {
                key: 'carouselinterval',
                title: '轮播间隔'
            },

            {
                key: 'videosrc',
                title: '视频地址'
            },
        ]
        arr.forEach(item => {
            if (item.key.toLowerCase() === key.toLowerCase()) {
                str = item.title
            }
        })
        return str
    },

    // php 的 array_column
    array_column(array, field) {
        return array.length ? array.map(v => v[field]) : []
    },

    // 对象去除 空，null
    obj_filter(obj) {
        for (let key in obj) {
            if (obj[key] === null) {
                delete obj[key]
            }
            if (typeof obj[key] === 'string' && obj[key].length === 0) {
                delete obj[key]
            }
        }
        return obj
    },


    getRoom(user){
        let res = ''
        if (user && user.room && user.room.hasOwnProperty('id')) {
            res = user.room.name
        }
        return res
    },
    getDepartment(user){
        let res = ''
        if (user && user.department && user.department.hasOwnProperty('id')) {
            res = user.department.name
        }
        return res
    },
    getPositionw(user){
        let res = ''
        if (user && user.positionw && user.positionw.hasOwnProperty('id')) {
            res = user.positionw.name
        }
        return res
    },
    getStus(user){
        let res = ''
        if (user && user.stus && user.stus.hasOwnProperty('id')) {
            res = user.stus.name
        }
        return res
    },










     // 加密
     encrypt(word,token='') {
        if(!token){
            token = getToken()
        }
        let key = token ? token.substr(8,16) : "inju165iuheifAS"
        let iv = token ? token.substr(6,16) : "inju165iuheifAS"
        let encrypted = CryptoJS.AES.encrypt(word, CryptoJS.enc.Utf8.parse(key), {
            iv:CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    
   
    // 解密
    decrypt(str,token='') {
            if(!token){
                token = getToken()
            }
            let key = token ? token.substr(8,16) : "inju165iuheifAS";
            let iv = token ? token.substr(6,16) : "inju165iuheifAS";
            let decrypt = CryptoJS.AES.decrypt(str,CryptoJS.enc.Utf8.parse(key), {
                iv:CryptoJS.enc.Utf8.parse(iv),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            })
            
            return JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
      },


      /**
   * 是否需要解密
   * @param {*} str 
   * @param {*} md5 
   * @param {*} token 
   * @returns 
   */
  depass(str,md5=RES_STATUS_ONE,token) {
    if(!token){
       token = getToken()
    }
    if(md5 == RES_STATUS_ONE){
      str = this.decrypt(str, token)
    }
    return str;
  },

  /**
   * 是否需要加密
   * @param {*} str 
   * @param {*} md5 
   * @param {*} token 
   * @returns 
   */
  isMd5(str,md5 = RES_STATUS_ONE,token){
    if(!token){
      token = getToken()
    }
    let data = {}
    if(md5 == RES_STATUS_ONE){
      data.src = this.encrypt(JSON.stringify(str), token)
    }else{
      data = src
    }
    return data;
  },


  //参数转换
  param(query,md5 = RES_STATUS_ONE) {
      let data = query;
      if (md5 == RES_STATUS_ONE) {
        data = this.isMd5(data,md5)
      }
      return data;
  },



  //回调地址
  callbackUrl:{
    1:hostApi +'/' + PUSHAPI +'/w_work/room_receive?id=1',
    2:hostApi +'/' + PUSHAPI +'/w_work/room_receive?id=1',
    3:hostApi +'/' + PUSHAPI +'/dingding/room_receive?id=1',
    4:hostApi +'/' + PUSHAPI +'/feishu/room_receive?id=1',
    5:hostApi +'/' + PUSHAPI +'/w_work/room_receive?id=1',
  }, 

  manualUrl:{
    1: hostApi + '/static/企业微信说明文档.docx',
    2: hostApi +'/static/企业微信代开发应用配置流程.doc',
    3: hostApi + '/static/钉钉说明文档.docx',
    4: hostApi + '/static/飞书配置流程.docx',
    5: hostApi + '/static/阿里云短信说明文档.docx',
  }, 

  //对接类型
docking:{
    0:{ id:1,name: '企业微信'},
    1:{ id:2,name: '企业微信代应用'},
    2:{ id:3,name: '钉钉'},
    3:{ id:4,name: '飞书'},
    4:{ id:5,name: '腾讯'},
    5:{ id:6,name: '网易'},
    6:{ id:7,name: 'outlook'},
    7:{ id:8,name: '公众号'},
    8:{ id:9,name: '小程序'},
    9:{ id:10,name: '微信支付'},
},

//会议类型
meeting_type:{
    0:{ id:1,name: '会议主题'},
    1:{ id:2,name: '预约类型'},
    2:{ id:3,name: '起始时间'},
    3:{ id:4,name: '结束时间'},
    4:{ id:5,name: '发起人'},
    5:{ id:6,name: '会议室'},
    6:{ id:7,name: '参与人'},
    7:{ id:8,name: '参与人数'},
    8:{ id:9,name: '会议物品'},
    9:{ id:10,name: '会议备注'},
    10:{ id:11,name: '会议附件'},
    11:{ id:12,name: '会议提醒'},
    12:{ id:13,name: '发起投票'},
    13:{ id:14,name: '会议纪要'},
},

//消息
message_type:{
    0:{ id:1,name: '邮箱'},
    1:{ id:2,name: '短信'},
    2:{ id:3,name: '公众号'},
    3:{ id:4,name: '小程序'},
    4:{ id:5,name: '默认'},
},

TimeType:[
    {
        value: '1',
        label: '日',
        name: 'days'
    },
    {
        value: '2',
        label: '月',
        name: 'months'
    },
    {
        value: '3',
        label: '年',
        name: 'years'
    },
],


typeSlicing(str){
    let param = '';

    if(str && typeof str === 'string'){
        if(str.length > 1){
            param = str.split(',').map(Number)
        }else{
            param = [str]
            param = param.map(Number)
        }
    }

    if(str && typeof str === 'object'){
        param = str
    }

    return param;
},


typeObjectConvert(object,str,defaultValue = ''){
    let param = '';
    if(str && typeof str === 'string'){
        if(str.length > 1){
            param = str.split(',')
        }else{
            param = [str]
        }
    }

    if(str && typeof str === 'object'){
        param = str
    }

    if(param.length <= 0){
        return param;
    }

    const matchedNames = Object.values(object).filter(item => {return param.some(p => String(item.id) === String(p))}).map(item => item.name);

    if (matchedNames.length === 0) return defaultValue;

    if (matchedNames.length === 1) return matchedNames[0];

    return matchedNames.join('、');

},

//获取授权时间
daysDifference(time,appId,status) {

     let data = this.depass(time,1,md5(appId))

    // 将字符串转换为 Date 对象
    const starts = new Date(data.start);
    const ends = new Date(data.end);

    // 计算时间差（毫秒）
    const diffTime = ends - starts;

    // 转换为天数
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if(status == 1){
        return data.start + '~' + data.end
    }else if(status == 2){
        return diffDays;
    }else{
        return ends
    }
  },

}